import jQuery  from 'jquery';
window.jQuery  = jQuery;
$  =  jQuery;

import { forceInt } from "../functions";

$(function () {

    const $dashboardProfile = $('.DashboardProfilePage');

  /* ========================================================================
   * Dashboard - Close Notification
   * ======================================================================== */
  $('.hide-notification','.dashboard-notification').on('click', function(e){
    e.preventDefault();

    if($(this).attr('objectid')) {
      $.ajax({
        type: "POST",
        url: window.location.protocol + '//' + window.location.hostname + window.location.pathname + '/closed-notification?id=' + $(this).attr('objectid'),
        dataType: 'json',
        success: function (data) {
          switch (data.status) {
            case 200:
              // Successful watch signal
              console.log('Announcement notification closed. Action saved.');
              break;
          }
        }
      });
    }

    $('.dashboard-notification').velocity({
      opacity:0
    },{
      duration: 300
    }).velocity({
        height: 0,
        paddingTop: 0
      },{
        duration: 300,
        complete: function(){
          $('.dashboard-notification').hide();
        }
      });
  });

    $("#ProfileImage").change(function(e) {

        for (var i = 0; i < e.originalEvent.srcElement.files.length; i++) {
            var file = e.originalEvent.srcElement.files[i];
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = function() {
                $(".imgProfileImage").attr('src', reader.result);
                $(".imgLiquid").imgLiquid({
                    fill: true,
                    horizontalAlign: "center",
                    verticalAlign: "50%"
                });
            }
        }
    });

    var $paymentHistory = $('.DashboardPaymentHistoryPage');
    if ($paymentHistory.length || $dashboardProfile.length) {

        $('.payment').on('click touch', function() {
            var $self = $(this);
            $(this).next('.payment-detail').first().fadeToggle(function() {

                $self.toggleClass('active');
                $self.children().children('.fa').toggleClass('fa-caret-up');
                $self.children().children('.fa').toggleClass('fa-caret-down');
            });
        });

    }

    const dashboardSidebar = $('.dashboard-sidebar');
    if (dashboardSidebar.length) {
        if (typeof gtmMemberCourses !== 'undefined') {
            if (gtmMemberCourses.length) {
                gtmMemberCourses.forEach(function(gtmMemberCourse) {
                    const li = dashboardSidebar.find('[data-id="' + gtmMemberCourse.course_id + '"]');
                    if (li.length) {
                        li.addClass('owned');
                        const aEl = li.find('a');
                        let dashboardHref = aEl.data('dashboard-href');
                        aEl.attr('href', dashboardHref);
                        aEl.removeAttr('target');
                    }
                });
            }
        }
    }

     const $yourCourses = $('.your-courses');
    if ($yourCourses.length) {
        if (typeof gtmMemberCourses !== 'undefined') {
            if (gtmMemberCourses.length) {
                gtmMemberCourses.forEach(function(gtmMemberCourse) {
                    const li = $yourCourses.find('[data-id="' + gtmMemberCourse.course_id + '"]');
                    if (li.length) {
                        li.addClass('owned');
                        const aEl = li.find('a');
                        let dashboardHref = aEl.data('dashboard-href');
                        aEl.attr('href', dashboardHref);
                        aEl.removeAttr('target');
                    }
                });
            }
        }
    }

    const $dashboardCoursePage = $('.dashboard-course');
    if ($dashboardCoursePage.length) {
        if (typeof completedComponentIds !== 'undefined' && completedComponentIds.length) {
            for (let n = 0, m = completedComponentIds.length; n < m; n++) {
                const completedComponentId = forceInt(completedComponentIds[n]);
                if (completedComponentId) {
                    const $courseComponent = $('.course-component[data-id="' + completedComponentId + '"]');
                    if ($courseComponent.length) {
                        $courseComponent.find('.tick').css('visibility', 'visible');
                    }
                }
            }
        }

        if (typeof quizzesCompleted !== 'undefined' && quizzesCompleted.length) {
            for (let n = 0, m = quizzesCompleted.length; n < m; n++) {
                const quiz = quizzesCompleted[n];
                const $quiz = $('.quiz[data-id="' + quiz.id + '"]');
                if ($quiz.length) {
                    const is100Percent = (quiz.score === quiz.questionsCount ? true : false),
                        scoreString = quiz.score + ' / ' + quiz.questionsCount,
                        $tick = $quiz.find('.tick');

                    $quiz.find('.score').text(scoreString);

                    $tick.find('.svg-tick').show();
                    $tick.find('.svg-plus').hide();
                    if (!is100Percent) {
                        $tick.find('.svg-tick').hide();
                        $tick.find('.svg-plus').show();
                        $tick.addClass('not-100-percent');
                    }

                    $tick.css('visibility', 'visible');
                }
            }
        }

        if (typeof memberHasReviewed !== 'undefined' && memberHasReviewed === true) {
            const $memberReview = $('.member-review');
            if ($memberReview.length) {
                const $tick = $memberReview.find('.tick'),
                    $title = $memberReview.find('.title');

                if ($tick.length) $memberReview.find('.tick').css('visibility', 'visible');
                if ($title.length) {
                    $title.text($title.data('has-reviewed-text'));
                }
            }
        }
    }

    const rafURLFieldWrapper = $('.raf-url-field-wrapper');
    if (rafURLFieldWrapper.length) {
        const rafURLField = $('#raf-url'),
            rafURLFieldBtn = rafURLFieldWrapper.find('.btn-raf-copy-url'),
            defaultBtnText = rafURLFieldBtn.text(),
            rafURLFieldCopy = function() {
                rafURLField.select();
                document.execCommand("copy");
                rafURLFieldBtn.text('Copied!');
                setTimeout(function() {
                    rafURLFieldBtn.text(defaultBtnText);
                }, 2000);
            };

        rafURLField.on('click', rafURLFieldCopy);
        rafURLFieldBtn.on('click', rafURLFieldCopy);
    }

    const $profileCompleteForm = $('#ProfileCompleteForm_ProfileCompleteForm');
    if ($profileCompleteForm.length) {
        const $profileCompleteFormSubmit = $('#ProfileCompleteForm_Submit');
        $profileCompleteFormSubmit.on('click', function() {
            $profileCompleteForm.submit();
        });

        $.get('https://ipinfo.io', { token: '91df9605e36b3f' }, function() {}, 'jsonp').always(function(data) {
            const countryCode = data && data.country ? data.country : '';

            if (countryCode !== '') {
                const countryName = countryIso2List[countryCode],
                    $countryDropdown = $('#Country');

                if ($countryDropdown.length) {
                    $countryDropdown.val(countryName).trigger('chosen:updated');
                }
            }
        });
    }

    const $affiliatePage = $('.dashboard-affiliate');
    if ($affiliatePage.length) {
        const $linkbuilderSelect = $('.affiliate-linkbuilder-select');
        if ($linkbuilderSelect.length) {
            let defaultBtnText = '';

            const linkBuilderUrlCopy = function() {
                const $affiliateCampaign = $(this).parents('.affiliate-campaign');
                if ($affiliateCampaign.length) {
                    const $linkbuilderUrlWrapper = $affiliateCampaign.find('.affiliate-linkbuilder-url-wrapper'),
                        $linkbuilderUrlField = $linkbuilderUrlWrapper.find('.affiliate-linkbuilder-url-field'),
                        $linkbuilderUrlBtn = $linkbuilderUrlWrapper.find('.affiliate-linkbuilder-url-btn');

                    $linkbuilderUrlField.select();
                    document.execCommand("copy");

                    $linkbuilderUrlBtn.text('Copied!');
                    setTimeout(function() {
                        $linkbuilderUrlBtn.text(defaultBtnText);
                    }, 2000);
                }
            };

            $linkbuilderSelect.selectmenu({
                change: function(event, ui) {
                    const $affiliateCampaign = $(this).parents('.affiliate-campaign');
                    if ($affiliateCampaign.length) {
                        const $linkbuilderUrlWrapper = $affiliateCampaign.find('.affiliate-linkbuilder-url-wrapper'),
                            $linkbuilderUrlField = $linkbuilderUrlWrapper.find('.affiliate-linkbuilder-url-field'),
                            $linkbuilderUrlBtn = $linkbuilderUrlWrapper.find('.affiliate-linkbuilder-url-btn'),
                            code = $affiliateCampaign.data('code');

                        if (defaultBtnText === '') {
                            defaultBtnText = $linkbuilderUrlBtn.text();
                            $linkbuilderUrlField.on('click', linkBuilderUrlCopy);
                            $linkbuilderUrlBtn.on('click', linkBuilderUrlCopy);
                        }

                        let url = '';
                        if ('url' in ui.item.element[0].dataset && ui.item.element[0].dataset.url) {
                            url = ui.item.element[0].dataset.url + '?c=' + code;
                        }

                        $linkbuilderUrlWrapper.hide();
                        if (url) {
                            $linkbuilderUrlField.val(url);
                            $linkbuilderUrlWrapper.show();
                        }
                    }
                }
            });
        }
    }


});



// WEBPACK FOOTER //
// ./js/modules/dashboard.js